// Descarga en el navegador de ficheros recibidos de la API
class FileDownload {
    // Guarda un blob como fichero con el nombre indicado
    static fromBlob(blob, fileName) {
        const href = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }

    // Nombre con la fecha de hoy: prefix_DD-MM-YYYY.extension
    static datedName(prefix, extension) {
        const date = new Date().toLocaleDateString("es-ES", {day: "2-digit", month: "2-digit", year: "numeric"});
        return `${prefix}_${date.replaceAll("/", "-")}.${extension}`;
    }
}

export default FileDownload;
